import React from 'react';
import { useIntl } from 'umi';
import classnames from 'classnames';
import SvgIcon from '@/pages/home/components/SvgIcon';
import AddBtn from '../AddBtn';
import type { IBaseProps, ICommonActionRes } from '@/pages/intelligence/types/common';
import type { IEntityFieldsMapping } from '../../types';
import './index.scss';

interface IEntitiesMetricsCompareTableHeaderProps extends IBaseProps {
  entities: any[];
  entityFieldsMapping: IEntityFieldsMapping;
  addBtnText?: string;
  addBtnDisabledTips?: string;
  columnRenderer: (entity: any, columnIndex: number) => React.ReactElement | null;
  onAdd?: (e: any) => void;
  onDelete?: (entity: any, columnIndex: number, e: React.SyntheticEvent<HTMLSpanElement>) => Promise<ICommonActionRes>;
  placeholder?: string;
}

export default function EntitiesMetricsCompareTableHeader(props: IEntitiesMetricsCompareTableHeaderProps) {
  const { formatMessage } = useIntl();

  const {
    entities,
    entityFieldsMapping,
    columnRenderer,
    addBtnText = formatMessage({ id: 'dbi_compare_add_games' }),
    addBtnDisabledTips = formatMessage({ id: 'dbi_compare_select_games_limit_tips' }, { max: 6 }),
    onAdd,
    onDelete,
    style,
    className,
  } = props;

  const entityIdField = entityFieldsMapping?.entityKey;

  const handleAddClick = (e: any) => {
    onAdd?.(e);
  };

  return (
    <div style={style} className={classnames('dbi-entities_table-header', className)}>
      <div className="dbi-entities_table-header-column first-column">
        <AddBtn
          className="dbi-entities_add-btn-container"
          disabled={entities?.length >= 6}
          text={addBtnText}
          disabledTips={addBtnDisabledTips}
          onClick={handleAddClick}
        />
      </div>
      {entities?.map((entity, i) => (
        <div key={entity?.[entityIdField]} className="dbi-entities_table-header-column">
          {columnRenderer?.(entity, i)}
          <SvgIcon
            className="dbi-entities_delete-icon"
            type="delete-bg-icon"
            onClick={(e) => {
              e?.stopPropagation();
              e?.preventDefault();
              onDelete?.(entity, i, e);
            }}
          />
        </div>
      ))}
    </div>
  );
}
